import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';
@Component({
  selector: 'app-recherche-modal',
  templateUrl: './recherche-modal.component.html',
  styleUrls: ['./recherche-modal.component.scss']
})
export class RechercheModalComponent implements OnInit {

  constructor(private router:Router,private dialogRef: MatDialogRef<RechercheModalComponent>,public generalService:GeneralService) { }
  art : any;

  ngOnInit() 
  {
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    }
  }
  ClearText()
  {
    this.art = ""
  }
  save() 
  {
    if(this.art != undefined)
      this.dialogRef.close(this.art);
    else
      alert("Veuillez choisir un elément")
  }

  close() 
  {
    this.dialogRef.close("");
  }
}
